import { createAction } from "@reduxjs/toolkit";
export const setExtraSpec = createAction("style/setExtraSpec");
